import React, { useEffect, useId, useState } from "react";
import { Combobox, Option } from "@fluentui/react-components";
import { useReduxDispatch, useReduxSelector } from "../redux/hooks/hooks";
import { setGroupSettings } from "../redux/slices/tabSlice";
import { userApi } from "../redux/api/userApi";
import { ISetting } from "../types/User/ISetting";
import { GroupDescriptor } from "@progress/kendo-data-query";
import IGridState from "../types/User/IGridState";

interface GroupListProps {
    // optional externally-controlled selected keys
    value?: string[];
    // called when selection changes
    onChange?: (keys: string[]) => void;
    label?: string;
}

export default function GroupList({ value, onChange, label = "Group by" }: GroupListProps) {
    const dispatch = useReduxDispatch();
    const [saveSetting] = userApi.useSaveSettingMutation();
    // read columns from tabSlice if not provided
    const { columns, groupSettings } = useReduxSelector((s) => s?.tab);
    const [selectedKeys, setSelectedKeys] = useState<string[]>(value ?? []);

    // keep internal state in sync if parent controls value
    useEffect(() => {
        if (Array.isArray(value)) setSelectedKeys(value);
    }, [value]);

    const groupableColumns = columns?.filter(c => c.groupable) ?? [];

    const groupsChanged = (keys: string[]) => {
        setSelectedKeys(keys);

        const newGroups = keys.map(k => ({ field: k, dir: "asc" } as GroupDescriptor))
        //dispatch(setGroupSettings(data.selectedOptions.map(field => ({ field, dir: "asc" }))));
        dispatch(setGroupSettings(newGroups));

        //perisst group settings to the server
        saveSetting({ Setting_Id: 146, Big_String_Value: JSON.stringify({ groups: newGroups, columns: columns } as IGridState) } as ISetting).unwrap()
            .then(() => {
                console.log("Group settings saved successfully");
            })
            .catch((error) => {
                console.error("Failed to save group settings:", error);
            })
    };

    const comboId = useId();
    const options = ["Cat", "Dog", "Ferret", "Fish", "Hamster", "Snake"];
    const comboValue = groupSettings?.length ? `Group: ${groupSettings?.map(g => columns?.find(c => c.groupField === g.field)?.groupTitle || columns?.find(c => c.groupField === g.field)?.title).join(', ')}` : '';

    return (
        <div className="full-screen-only">
            <Combobox multiselect appearance="underline"
                aria-labelledby={comboId}
                placeholder="Group by..."
                value={comboValue}
                selectedOptions={groupSettings?.map(g => g.field) ?? []}
                onOptionSelect={(_, data) => {
                    //setSelected(data.selectedOptions);
                    //console.log("GroupList onOptionSelect:", data.selectedOptions.map(field => columns?.find(c => c.field === field)));
                    groupsChanged(data.selectedOptions);
                }}>
                {groupableColumns?.map((option) => (
                    <Option key={option.field} value={option.groupField ?? option.field} >
                        {option.groupTitle || option.title}
                    </Option>
                ))}
            </Combobox>
        </div>
    );

    return (
        <div className="grid-option">
            {/* {JSON.stringify(groupSettings)} */}
            <Combobox
                appearance="underline" multiselect placeholder="Group by..."
                value={''}
                //value={groupSettings?.length ? `Group: ${groupSettings?.map(g => columns?.find(c => c.groupField === g.field)?.groupTitle || columns?.find(c => c.groupField === g.field)?.title).join(', ')}` : ''}
                //selectedOptions={groupSettings?.map(g => g.field) ?? ''} 
                onOptionSelect={(_, data) => {
                    //setSelected(data.selectedOptions);
                    //console.log("GroupList onOptionSelect:", data.selectedOptions.map(field => columns?.find(c => c.field === field)));
                    groupsChanged(data.selectedOptions);
                }}>
                <Option key={'test'} value={'Nope'}>
                    Nope
                </Option>
                {/* {groupSettings?.map((option) => (
                    <Option key={option.field} value={option.field || 'Nope'}>
                        {option.field || 'Nope'}
                    </Option>
                ))} */}
            </Combobox>
        </div>
    );
}